var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeoMagify1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 98,
    viewBox: "0 0 96 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.2412 0C16.2242 0 0 16.3241 0 36.4644C0 56.6047 16.2242 72.9288 36.2412 72.9288C56.2582 72.9288 72.4825 56.6047 72.4825 36.4644C72.4825 16.3241 56.2521 0 36.2412 0ZM36.2412 65.1128C20.5162 65.1128 7.76815 52.2863 7.76815 36.4644C7.76815 20.6425 20.5162 7.81599 36.2412 7.81599C51.9663 7.81599 64.7143 20.6425 64.7143 36.4644C64.7143 52.2863 51.9663 65.1128 36.2412 65.1128Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.104 58.0392L94.5893 89.7184C96.4704 91.6111 96.4704 94.6864 94.5893 96.5791C92.7081 98.4719 89.6517 98.4719 87.7705 96.5791L56.2852 64.9L63.1083 58.0349L63.104 58.0392Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.728 9.56175C39.3278 9.34124 37.891 9.22485 36.4299 9.22485C24.2663 9.22485 14.0082 17.0531 10.806 27.748C10.5442 28.6239 10.3311 29.5182 10.1668 30.4309C9.91108 31.852 10.8791 33.2119 12.3401 33.5365C13.9534 33.8979 15.518 32.8688 15.8102 31.3069C15.9564 30.5228 16.1451 29.751 16.3825 28.9976C18.9881 20.7283 26.9815 14.7132 36.436 14.7132C37.4527 14.7132 38.4511 14.7867 39.4313 14.9215C40.2775 15.0378 41.1054 15.2032 41.9151 15.4115C43.4858 15.8219 45.1052 14.9215 45.4766 13.3962C45.8236 11.9752 44.9591 10.5173 43.498 10.1314C42.597 9.89252 41.6777 9.70263 40.7463 9.55562L40.728 9.56175Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_437"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 98,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeoMagify1);
export default __webpack_public_path__ + "static/media/SEO_magify 1.c4816f50fcfe8cb93939f81e108150d9.svg";
export { ForwardRef as ReactComponent };